import React, { useMemo, useContext } from 'react';
import NotificationsContext from 'providers/Notifications/Notifications.context';
import NotificationCard from 'components/NotificationCard';
import { getHasElementsInArray } from 'utils';
import NotificationPlaceholder from 'components/NotificationPlaceholder';

export default function useNotifications() {
  const {
    notifications,
    fetchingNotifications,
    numberOfPlaceholders,
    redirectionPath,
    getDynamicRedirectionPath,
    onDeleteNotification,
    onReadNotification,
    onUnreadNotification,
    getCtaIcon,
    getCtaPrimary,
    getCtaSecondary,
    getCtaText,
    getContent,
    getIsLoadingNotification,
  } = useContext(NotificationsContext);

  const showEmptyState = useMemo(
    () => !fetchingNotifications && !getHasElementsInArray(notifications),
    [fetchingNotifications, notifications],
  );

  const placeholders = useMemo(
    () => (
      <div className="notifications-placeholders">
        {fetchingNotifications &&
          Array(numberOfPlaceholders)
            .fill(1)
            .map((_, i) => <NotificationPlaceholder key={i} />)}
      </div>
    ),
    [fetchingNotifications, numberOfPlaceholders],
  );

  const renderedCards = useMemo(
    () =>
      notifications.map((notif) => (
        <NotificationCard
          key={notif.id}
          notification={notif}
          loading={getIsLoadingNotification(notif.id)}
          to={redirectionPath(notif)}
          onDynamicTo={getDynamicRedirectionPath(notif)}
          onRead={onReadNotification}
          onUnread={onUnreadNotification}
          onDelete={onDeleteNotification}
          ctaPrimary={getCtaPrimary(notif)}
          ctaSecondary={getCtaSecondary(notif)}
          ctaText={getCtaText(notif)}
          ctaIcon={getCtaIcon(notif)}
          contentText={getContent(notif)}
        />
      )),
    [
      notifications,
      getContent,
      getCtaIcon,
      getCtaPrimary,
      getCtaSecondary,
      getCtaText,
      getDynamicRedirectionPath,
      getIsLoadingNotification,
      onDeleteNotification,
      onReadNotification,
      onUnreadNotification,
      redirectionPath,
    ],
  );

  return { showEmptyState, placeholders, renderedCards };
}
